// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
// Vuetify
import { createVuetify } from 'vuetify'
// import colors from 'vuetify/lib/util/colors'

export default createVuetify({
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#5711A5', // #E53935
          secondary: '#6C63FF', // #FFCDD2
          Info: '#ffaa2c',
          error: '#f83e70',
          fontColorHeading: '#35437A'
        }
      },
    },
  },
})
